export const BlobToFile = ({name, data, mimeString}) => new File([data], name, {type: mimeString});